// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentExternalAccountDetail {
    static getAttributeTypeMap() {
        return DigitalpaymentExternalAccountDetail.attributeTypeMap;
    }
}
DigitalpaymentExternalAccountDetail.discriminator = undefined;
DigitalpaymentExternalAccountDetail.additionalProperties = false;
DigitalpaymentExternalAccountDetail.attributeTypeMap = [
    {
        "name": "bankAccount",
        "baseName": "bankAccount",
        "type": "DigitalpaymentBankAccountDetail"
    },
    {
        "name": "externalAccountAliasId",
        "baseName": "externalAccountAliasId",
        "type": "string"
    },
];
//# sourceMappingURL=digitalpaymentExternalAccountDetail.js.map